import React, { useRef, useState } from "react";
import { Button, ButtonGroup, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Add, ArrowDropDown, UploadFile } from "@mui/icons-material";

// Replaces what used to be 1-3 separate always-visible buttons (New
// Shipment, Bulk Add, Bulk Import) with a single primary action plus a
// small dropdown arrow that reveals the bulk options — same "split button"
// pattern on the Dashboard and the Shipments list, for both admin and
// customer. When neither bulk option is available to this user, it quietly
// degrades to a plain button (no dropdown arrow, nothing to reveal).
export default function NewShipmentSplitButton({
  label = "New Shipment",
  onNewShipment,
  canBulkAdd = false,
  onBulkAdd,
  canBulkImport = false,
  onBulkImport,
  disabled = false,
  disabledTooltip = "",
  fullWidth = false,
  variant = "contained",
  size,
}) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const hasBulkOptions = canBulkAdd || canBulkImport;

  const mainButton = (
    <Button
      variant={variant}
      size={size}
      startIcon={<Add />}
      onClick={onNewShipment}
      disabled={disabled}
      fullWidth={fullWidth && !hasBulkOptions}
      sx={hasBulkOptions ? { flex: fullWidth ? 1 : undefined } : undefined}
    >
      {label}
    </Button>
  );

  if (!hasBulkOptions) {
    return disabledTooltip ? (
      <Tooltip title={disabled ? disabledTooltip : ""}>
        <span style={fullWidth ? { display: "block", width: "100%" } : undefined}>{mainButton}</span>
      </Tooltip>
    ) : (
      mainButton
    );
  }

  return (
    <>
      <Tooltip title={disabled ? disabledTooltip : ""}>
        <ButtonGroup
          ref={anchorRef}
          variant={variant}
          disabled={disabled}
          sx={fullWidth ? { width: "100%" } : undefined}
        >
          {mainButton}
          <Button
            size={size}
            sx={{ px: 0.5 }}
            onClick={() => setOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={open ? "true" : undefined}
          >
            <ArrowDropDown />
          </Button>
        </ButtonGroup>
      </Tooltip>
      <Menu anchorEl={anchorRef.current} open={open} onClose={() => setOpen(false)}>
        {canBulkAdd && (
          <MenuItem
            onClick={() => {
              setOpen(false);
              onBulkAdd();
            }}
          >
            <ListItemIcon>
              <Add fontSize="small" />
            </ListItemIcon>
            <ListItemText>Bulk Add (Manual Entry)</ListItemText>
          </MenuItem>
        )}
        {canBulkImport && (
          <MenuItem
            onClick={() => {
              setOpen(false);
              onBulkImport();
            }}
          >
            <ListItemIcon>
              <UploadFile fontSize="small" />
            </ListItemIcon>
            <ListItemText>Bulk Import (CSV)</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
